<template>
    <div class="w-full">
        <h1 class="header-class">
            <vue-feather type="coffee" size="18px" class="-mb-[2px]" aria-hidden="true" />
            Recipes
        </h1>
        <div class="w-full flex flex-wrap items-start text-slate-300">
            <RecipeList class="recipes w-full md:w-1/2" :recipes="recipes" :recipe="recipe" ></RecipeList>
            <!-- <ul class="flex flex-wrap justify-start pt-4 w-full md:w-1/2 pr-4 border-r border-r-slate-600/50">
                <li class="w-full">
                    <label for="sort" class="text-sm text-slate-400 ml-1">Sort:</label>
                    <ul class="sort flex flex-wrap justify-center items-center">
                        <li v-for="sortOption in ['newest', 'oldest', 'name']" :key="sortOption" :class="[order == sortOption ? 'bg-slate-100 text-slate-800' : 'bg-slate-500 text-slate-50', 'flex-1 text-center  py-1 cursor-pointer mx-1 px-1']">
                            <button @click="order=sortOption">
                                {{ sortOption }}
                            </button>
                        </li>
                    </ul>
                </li>
                <li class="w-full my-2">
                    <label for="searchbox" class="text-sm text-slate-400">Search by culture, name or
                        ingredient:</label>
                    <input id="searchbox" class="border-1 border-gray-400/50 border p-1 w-full" type="text" v-model="term" placeholder="Enter some stuff">
                </li>
                <li v-for="r in recipesFiltered" class="recipe w-1/6 mb-1" :key="r.id">
                    <Link :href="`/recipes/${r.slug}`" :only="['recipe']" class="flex flex-col group justify-end p-1 pt-2">
                    <img :class="[r.id==recipe?.id ? 'scale-105' : 'grayscale-50','pic group-hover:scale-105  group-hover:grayscale object-cover h-24']" :src="printBG(r)" :alt="r.name"/>
                    <h2 :class="[r.id==recipe?.id ? 'text-yellow-200 italic' : 'text-gray-200','group-hover:text-yellow-200 w-full z-20 text-sm py-1 min-h-10 flex flex-wrap text-center items-center justify-center px-2 pl-1 -mt-1 leading-tight']">
                        {{ r.name }}</h2>
                    </Link>
                </li>
            </ul> -->
            <div class="w-full md:w-1/2 mt-6 pl-4">
                <RecipeCard v-if="recipe" :recipe="recipe" class="recipe-card sticky top-24" />
                <ul class="flex flex-wrap p-2">
                    <li class="bg-slate-300 w-full px-4 mb-2" aria-hidden="true">
                        <h4 class="text-black">Ingredients Breakdown</h4>
                        <ShowsBarChart class="pb-2" :dataset="ingredientsBreakdown" :maintain-aspect-ratio="false" :responsive="true" />
                    </li>
                    <li class="bg-slate-300 px-4 w-full" aria-hidden="true">
                        <h4 class="text-black">Origin Breakdown</h4>
                        <ShowsBarChart class="pb-2" :dataset="originBreakdown" label="Origin Breakdown"
                            :maintain-aspect-ratio="false" :responsive="true" />
                    </li>
                </ul>
            </div>
        </div>

    </div>
</template>
<script>
    import { mapState } from 'pinia'
    import { useGeneralStore } from '@/utils/useGeneralStore.js'
    import preloader from '@/utils/preloader.js';
    import ShowsBarChart from '@/Components/ShowsBarChart.vue';
    import RecipeCard from '@/Components/RecipeCard.vue'
    import { Link } from '@inertiajs/vue3';
    import RecipeList from '@/Components/RecipeList.vue'
    import GuestLayout from '@/Layouts/GuestLayout.vue';
    import { gsap } from 'gsap/all'

    export default {
        layout: GuestLayout,
        watch: {
            order(o) {
                this.getRecipes();
            },
            '$page.url': {
                handler(n, o) {
                    gsap.fromTo('.recipe',
                        { scaleY: 1.2, x: 20, y: -20, opacity: 0 },
                        { scaleY: 1, x: 0, y: 0, opacity: 1, stagger: .01, duration: .5, ease: "back.out(2.4)"},
                    )
                },
                deep: true,
                immediate: true
            }
        },
        components: { Link, RecipeCard, RecipeList, ShowsBarChart },
        props: ['showeditbar', 'token', 'ingredientsBreakdown', 'originBreakdown', 'recipes', 'recipe'],
        computed: {
            ...mapState(useGeneralStore, ['bbSectionHeader', 'containerClass', 'headerClass', 'subheaderClass']),
            recipesFiltered() {
                let repfilt=this.recipes;
                if(this.term) {
                    repfilt=repfilt.filter(r =>
                        r.name?.toLowerCase().indexOf(this.term.toLowerCase()) > -1 ||
                        r.description?.toLowerCase().indexOf(this.term.toLowerCase()) > -1 ||
                        r.food_type?.toLowerCase().indexOf(this.term.toLowerCase()) > -1
                    );
                }

                return this.sort(repfilt);
            }
        },
        data() {
            return {
                order: 'newest',
                term: null,
                imageWidth: 300,
                imagesLoaded: false,
                ingredientBarData: null,
                originBarData: null
            }
        },
        // beforeMount() {
        //     this.getRecipes();

        // },
        mounted() {
            // gsap.to('.panel', {opacity: 1, stagger: .03, duration: 1});
            // gsap.fromTo('.recipes', {opacity: 0}, {stagger: .05 , opacity: 1, scale: 1, duration: .1, ease:"expoScale(1, 2)"});

        },
        methods: {
            rotator(index) {
                let delt = index % 2;
                switch (delt) {
                    case 0:
                        return 'counter-clockwise'
                    case 1:
                    default:
                        return 'clockwise'
                }
            },
            printBG(r) {
                if(!r.img) {
                    r.img='no-image.jpg';
                }
                // return `/recipe-image/${r.img}/${this.imageWidth}`;
                return `/api/get-recipe-image/${r.img}`;
            },
            sort(rs) {
                switch(this.order) {
                    case 'name':
                    default:
                        return rs.sort((a, b) => a.name > b.name);
                    case 'newest':
                        return rs.sort((a,b) => a.created_at < b.created_at);
                    case 'oldest':
                        return rs.sort((a,b) => a.created_at > b.created_at);
                }

            },
            getRecipes() {
                // this.recipes = [];
                this.imagesLoaded = false;
                // DataService.client.get('recipe-data/'+(this.page ? this.page : 1) + '/'+ this.order + '/' + (this.term ? this.term : '')
                //   )
                //   .then((response) => {
                //     this.recipes=response.data.data;

                //   })
                //   .catch(function (error) {
                //     // this.$store.commit('mutate', {property: 'loading', with: false});
                //   })
                //   .finally(() => {
                // this.getIngredientBreakdown();
                preloader.preloadImages(this.recipes, this.imageWidth).finally(() => {
                    this.imagesLoaded = true;
                    //         gsap.fromTo(".recip",
                    //     { y: 30, opacity: 0 },
                    //     {
                    //         rotation: .4,
                    //         duration: 0.15,
                    //         y: 0,
                    //         ease: "elastic.out(.3,.3)",
                    //         stagger: 0.01,
                    //         opacity: 1
                    //     }
                    // );
                });
                //}
                //   })
            },

        }
    }
</script>
<style lang="postcss">
    .recipe {
        opacity: 1;

    }
    .recipe img {
        transition: all .25s cubic-bezier(0.165, 0.84, 0.44, 1);
    }

    .pill {
        @apply border bg-white rounded-md px-4 text-center text-base;
    }
    .recipe-card {
        transform-origin: top;;
    }
</style>
